export const targetsQueryKeys = {
  all: ["targets"],

  report: ({ level, dc, entityId, year, month } = {}) =>
    [...targetsQueryKeys.all, "report", { level, dc, entityId, year, month }],

  personnel: (personnelId) =>
    [...targetsQueryKeys.all, "personnel", personnelId],

  suggested: ({ personnelId, manufacturerId, productGroupId, year, month } = {}) =>
    [
      ...targetsQueryKeys.all,
      "suggested",
      { personnelId, manufacturerId, productGroupId, year, month },
    ],

  coverage: (year, month, calendarType) =>
    [...targetsQueryKeys.all, "coverage", year, month, calendarType || "jalali"],

  distribution: (year, month, calendarType) =>
    [...targetsQueryKeys.all, "distribution", year, month, calendarType || "all"],

  monthCustomer: (personnelId, year, month) =>
    [...targetsQueryKeys.all, "month-customer", personnelId, year || null, month || null],
};
